import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/insights/forms/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/newsletter/subscribers" });
  },
});
